<template>
    <v-container class="pa-0">
        <v-row align="center">
            <template v-if="editable">
                <v-col cols="auto" class="pa-0 px-1">
                    <slot name="label">
                        <span class="text-body-2">{{label}}</span>
                    </slot>
                </v-col>
                <v-col cols="10" class="pa-0 px-1">
                    <slot name="text-field">
                        <v-text-field
                            v-model="text"
                            :placeholder="placeholder"
                            :disabled="disabled"
                            :rules="rules"
                            :type="type"
                            :hint="hint"
                            :error-messages="errorMessages"
                            :error="error"
                            :onpaste="'return '+(!cannotPaste).toString()"
                            :oncopy="'return '+(!cannotCopy).toString()"
                            :oncontextmenu="'return '+(!cannotContextMenu).toString()"
                            :hide-details="hideDetails"
                            outlined
                            dense
                            color="primary"
                        />
                    </slot>
                </v-col>
            </template>
            <template v-else>
                <v-col cols="auto" class="pa-0 text-body-2">{{label}}</v-col>
                <v-col cols="auto" class="pa-0 text-body-2">{{text ? text : 'なし'}}</v-col>
            </template>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'TextFieldHorizen',
    model: {
        prop: 'value'
    },
    props:{
        editable: {
            type: Boolean,
            default: true
        },
        label: {
            type: String,
            default: ''
        },
        value: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        },
        rules: {
            type: Array,
            default: () => {[]}
        },
        disabled: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: "text"
        },
        errorMessages: {
            type: Array,
            default: () => {[]}
        },
        error: {
            type: Boolean,
            default: false
        },
        hint: {
            type: String,
            default: undefined
        },
        hideDetails: {
            type: Boolean,
            default: false
        },
        'cannot-paste': {
            type: Boolean,
            default: false
        },
        'cannot-copy': {
            type: Boolean,
            default: false
        },
        'cannot-context-menu': {
            type: Boolean,
            default: false
        }
    },
    computed: {
        text: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
}
</script>